import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { GenderEffect } from './store.effects';
import { STORE_TYPE } from './store.model';
import { uiReducer } from './store.reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(STORE_TYPE, uiReducer), EffectsModule.forFeature([GenderEffect])],
  exports: [],
})
export class UIGenderStoreModule {}
